// ============================================
// TECH MYTH BUSTERS  - MYTHS DATA
// ============================================
// To add, edit, or remove a myth, just modify the array below.
// Each myth needs: id, category, statement, answer (true/false),
// relatedProductId, and explanation.
//
// HOW TO ADD A MYTH:
//   Copy any object below, paste it at the end of the array,
//   change the id to the next number, fill in the fields, save.
//   No build step needed  - just refresh the page.
//
// relatedProductId: must match a key in products.js, or null.
//   If the user answers this myth incorrectly, that collection
//   will be shown in the product recommendations at the end.
//
// CATEGORIES COVERED:
//   BATTERY, RAM, STORAGE, MONITOR, ADAPTER, NETWORKING,
//   ROUTER, NAS, GPU, COOLING, POWER, KEYBOARD, AUDIO,
//   PROCESSOR, MOTHERBOARD, PRINTER, SECURITY, GAMING,
//   MAINTENANCE, CABLE, LAPTOP, GENERAL TECH
//
// TRUE/FALSE BALANCE: ~50/50
// ============================================

window.MYTHS = [

  // ──────────────────────────────────────────
  //  BATTERY MYTHS (1–6)
  // ──────────────────────────────────────────
  {
    id: 1,
    category: "BATTERY",
    statement: "You should always fully discharge your laptop battery before recharging.",
    answer: false,
    relatedProductId: "battery-1",
    explanation: "Modern lithium-ion batteries last longer with partial charges. Full discharges actually degrade them faster. Charge whenever you want."
  },
  {
    id: 2,
    category: "BATTERY",
    statement: "Keeping your laptop plugged in 24/7 will reduce battery lifespan over time.",
    answer: true,
    relatedProductId: "battery-1",
    explanation: "Partially true  - modern laptops have charge limiters, but constant heat from charging does reduce lifespan over time. Unplug occasionally."
  },
  {
    id: 3,
    category: "BATTERY",
    statement: "Third-party OEM batteries are always lower quality than the ones that came with your laptop.",
    answer: false,
    relatedProductId: "battery-1",
    explanation: "Genuine OEM batteries from trusted sellers like TPSTech use the same cells and specs as the originals. The key is buying from an authorized source, not just any random seller."
  },
  {
    id: 4,
    category: "BATTERY",
    statement: "Laptop batteries degrade even when not in use.",
    answer: true,
    relatedProductId: "battery-1",
    explanation: "Lithium-ion batteries lose about 2–3% capacity per month even when stored. For long-term storage, keep them at 40–60% charge in a cool place."
  },
  {
    id: 5,
    category: "BATTERY",
    statement: "Using your laptop while charging damages the battery.",
    answer: false,
    relatedProductId: "battery-1",
    explanation: "Modern laptops are designed to be used while charging. The power system manages battery and AC input separately. Use it however you like."
  },
  {
    id: 6,
    category: "BATTERY",
    statement: "A laptop battery with higher Whr (watt-hours) rating will last longer per charge.",
    answer: true,
    relatedProductId: "battery-1",
    explanation: "Watt-hours is a direct measure of energy capacity. A 68Whr battery stores more energy than a 42Whr one, so it will last longer under the same workload."
  },

  // ──────────────────────────────────────────
  //  ADAPTER & CHARGER MYTHS (7–12)
  // ──────────────────────────────────────────
  {
    id: 7,
    category: "ADAPTER",
    statement: "Using a higher-wattage adapter than your laptop requires will damage it.",
    answer: false,
    relatedProductId: null,
    explanation: "Your laptop only draws the power it needs. A 90W adapter on a 65W laptop is perfectly safe  - the laptop won't pull more than 65W. Going lower in wattage is the actual risk."
  },
  {
    id: 8,
    category: "ADAPTER",
    statement: "A lower-wattage charger than recommended can cause your laptop to lose charge even while plugged in.",
    answer: true,
    relatedProductId: null,
    explanation: "If the adapter can't supply enough power for your laptop's workload, the battery will drain even while connected. Always match or exceed the recommended wattage."
  },
  {
    id: 9,
    category: "ADAPTER",
    statement: "All USB-C chargers work the same across all USB-C laptops.",
    answer: false,
    relatedProductId: null,
    explanation: "USB-C Power Delivery has different wattage profiles (20W, 45W, 65W, 100W, 140W). A low-wattage phone charger won't properly power a laptop that needs 65W+."
  },
  {
    id: 10,
    category: "ADAPTER",
    statement: "Using a non-original but same-spec adapter will void your laptop warranty.",
    answer: false,
    relatedProductId: null,
    explanation: "In most countries, using a compatible third-party adapter doesn't void your warranty unless it physically damages the device. Your consumer rights protect you."
  },
  {
    id: 11,
    category: "ADAPTER",
    statement: "Laptop adapters consume electricity even when the laptop isn't connected.",
    answer: true,
    relatedProductId: null,
    explanation: "Plugged-in adapters draw a small amount of standby power (vampire drain). It's minimal, but unplugging saves energy over time."
  },
  {
    id: 12,
    category: "ADAPTER",
    statement: "Fast charging always degrades your battery faster than slow charging.",
    answer: false,
    relatedProductId: "battery-1",
    explanation: "Modern fast-charging tech manages heat and voltage carefully. Degradation depends more on heat and charge cycles than charging speed alone."
  },

  // ──────────────────────────────────────────
  //  MONITOR & DISPLAY MYTHS (13–19)
  // ──────────────────────────────────────────
  {
    id: 13,
    category: "MONITOR",
    statement: "A higher refresh rate monitor automatically makes you better at gaming.",
    answer: false,
    relatedProductId: "monitor-1",
    explanation: "Smoother visuals help reaction time slightly, but skill, practice, and game sense beat specs every single time."
  },
  {
    id: 14,
    category: "MONITOR",
    statement: "IPS panels have better color accuracy than TN panels.",
    answer: true,
    relatedProductId: "monitor-1",
    explanation: "IPS (In-Plane Switching) panels offer wider viewing angles and more accurate, consistent colors. TN panels are faster but wash out at angles."
  },
  {
    id: 15,
    category: "MONITOR",
    statement: "A 4K monitor is always better than a 1080p monitor.",
    answer: false,
    relatedProductId: "monitor-1",
    explanation: "On a small screen (24 inches or under), most people can't tell the difference. Plus, 4K needs a much more powerful GPU to run games smoothly."
  },
  {
    id: 16,
    category: "MONITOR",
    statement: "Curved monitors reduce eye strain compared to flat monitors.",
    answer: true,
    relatedProductId: "monitor-1",
    explanation: "Curved screens match the natural curvature of your eyes, reducing the need to refocus at the edges. This helps during long work sessions, especially on ultrawide displays."
  },
  {
    id: 17,
    category: "MONITOR",
    statement: "You need an expensive calibration tool to get accurate colors on any monitor.",
    answer: false,
    relatedProductId: "monitor-1",
    explanation: "Many modern IPS monitors come factory-calibrated to sRGB or DCI-P3 standards. For most work, the out-of-box calibration is perfectly good."
  },
  {
    id: 18,
    category: "MONITOR",
    statement: "Blue light filters on monitors can help reduce sleep disruption at night.",
    answer: true,
    relatedProductId: "monitor-1",
    explanation: "Blue light suppresses melatonin production. Using a blue light filter or night mode in the evening genuinely helps your sleep cycle."
  },
  {
    id: 19,
    category: "MONITOR",
    statement: "Portable monitors are only useful for people who travel frequently.",
    answer: false,
    relatedProductId: "monitor-1",
    explanation: "Portable monitors are great as secondary displays for WFH setups, presentations, console gaming on the go, or even as a quick dual-screen setup in small spaces."
  },

  // ──────────────────────────────────────────
  //  RAM & MEMORY MYTHS (20–25)
  // ──────────────────────────────────────────
  {
    id: 20,
    category: "RAM",
    statement: "More RAM always makes your computer faster.",
    answer: false,
    relatedProductId: "ram-1",
    explanation: "Beyond 16GB, extra RAM won't help most users. Your CPU or storage is usually the real bottleneck. RAM helps only if you're actually running out of it."
  },
  {
    id: 21,
    category: "RAM",
    statement: "Mixing different RAM brands in a PC can cause instability.",
    answer: true,
    relatedProductId: "ram-1",
    explanation: "While it sometimes works, mixing brands with different timings, voltages, or speeds can cause crashes, blue screens, or force both sticks to run at the slower speed."
  },
  {
    id: 22,
    category: "RAM",
    statement: "DDR5 RAM is always faster than DDR4 for every task.",
    answer: false,
    relatedProductId: "ram-1",
    explanation: "Early DDR5 had higher latency than mature DDR4. For many everyday tasks, DDR4-3600 performs comparably to base DDR5-4800. DDR5 shines more in bandwidth-heavy workloads."
  },
  {
    id: 23,
    category: "RAM",
    statement: "Running RAM in dual-channel mode gives a noticeable performance boost.",
    answer: true,
    relatedProductId: "ram-1",
    explanation: "Dual-channel doubles the memory bandwidth. It's especially noticeable in gaming, video editing, and integrated graphics performance  - always use two sticks."
  },
  {
    id: 24,
    category: "RAM",
    statement: "You can upgrade RAM on any laptop.",
    answer: false,
    relatedProductId: "ram-1",
    explanation: "Many modern ultrabooks have RAM soldered to the motherboard. Always check if your laptop has accessible RAM slots before buying an upgrade."
  },
  {
    id: 25,
    category: "RAM",
    statement: "Clearing your RAM by closing background apps can genuinely speed up a slow PC.",
    answer: true,
    relatedProductId: "ram-1",
    explanation: "If your system is actively running low on RAM (high usage in Task Manager), closing unnecessary apps frees memory and reduces slowdowns caused by disk swapping."
  },

  // ──────────────────────────────────────────
  //  STORAGE & SSD MYTHS (26–31)
  // ──────────────────────────────────────────
  {
    id: 26,
    category: "STORAGE",
    statement: "SSDs don't need defragmentation like HDDs.",
    answer: true,
    relatedProductId: "ssd-1",
    explanation: "Correct! Defragging an SSD is pointless and can even reduce its lifespan by causing unnecessary writes. SSDs access data randomly, not sequentially."
  },
  {
    id: 27,
    category: "STORAGE",
    statement: "NVMe SSDs are always faster than SATA SSDs for everyday tasks.",
    answer: false,
    relatedProductId: "ssd-1",
    explanation: "For booting, browsing, and office work, you won't notice a difference. NVMe's speed advantage is mainly in large file transfers, video editing, and heavy sequential workloads."
  },
  {
    id: 28,
    category: "STORAGE",
    statement: "SSDs have a limited number of write cycles and will eventually wear out.",
    answer: true,
    relatedProductId: "ssd-1",
    explanation: "True, but modern SSDs last incredibly long. A typical 1TB SSD can handle 600TB of writes  - that's decades of normal use for most people."
  },
  {
    id: 29,
    category: "STORAGE",
    statement: "Filling your SSD to near full capacity slows it down.",
    answer: true,
    relatedProductId: "ssd-1",
    explanation: "SSDs need free space for wear leveling and garbage collection. When nearly full, write speeds drop significantly. Try to keep at least 10–20% free."
  },
  {
    id: 30,
    category: "STORAGE",
    statement: "External SSDs are just as fast as internal ones.",
    answer: false,
    relatedProductId: "ssd-1",
    explanation: "External SSDs are limited by the USB interface. Even USB 3.2 Gen 2 caps at ~1000 MB/s, while internal NVMe SSDs can hit 7000+ MB/s."
  },
  {
    id: 31,
    category: "STORAGE",
    statement: "Hard drives are still better than SSDs for long-term data archival.",
    answer: true,
    relatedProductId: "ssd-1",
    explanation: "For cold storage (data sitting unused for years), HDDs are more reliable. Unpowered SSDs can lose data over time as charge leaks from the flash cells."
  },

  // ──────────────────────────────────────────
  //  NETWORKING & ROUTER MYTHS (32–40)
  // ──────────────────────────────────────────
  {
    id: 32,
    category: "NETWORKING",
    statement: "Restarting your router actually fixes connectivity issues.",
    answer: true,
    relatedProductId: null,
    explanation: "Routers accumulate memory leaks, stale DNS caches, and connection tables over time. A restart clears all of this and genuinely resolves many issues."
  },
  {
    id: 33,
    category: "NETWORKING",
    statement: "A more expensive router always means faster internet speeds.",
    answer: false,
    relatedProductId: null,
    explanation: "Your internet speed is capped by your ISP plan. A ₹10,000 router won't make a 100 Mbps plan faster  - but it will improve coverage, device handling, and reliability."
  },
  {
    id: 34,
    category: "ROUTER",
    statement: "Placing your Wi-Fi router on the floor gives the best coverage.",
    answer: false,
    relatedProductId: null,
    explanation: "Wi-Fi signals spread outward and downward. Placing the router high up  - on a shelf or mounted on a wall  - gives much better coverage across your home."
  },
  {
    id: 35,
    category: "ROUTER",
    statement: "Wi-Fi 6 routers are backward compatible with older Wi-Fi 5 devices.",
    answer: true,
    relatedProductId: null,
    explanation: "Wi-Fi standards are backward compatible. A Wi-Fi 6 router works with Wi-Fi 5, 4, and even older devices  - they just connect at the older, slower standard."
  },
  {
    id: 36,
    category: "NETWORKING",
    statement: "Hiding your Wi-Fi SSID (network name) makes it more secure.",
    answer: false,
    relatedProductId: null,
    explanation: "Hidden SSIDs are easily discovered by anyone with basic tools. It adds inconvenience for you, not security. Use a strong WPA3 password instead."
  },
  {
    id: 37,
    category: "ROUTER",
    statement: "Mesh Wi-Fi systems are better than single routers for large homes.",
    answer: true,
    relatedProductId: null,
    explanation: "Mesh systems use multiple nodes to blanket large areas with consistent coverage. A single router struggles with dead zones in homes over 1000–1500 sq ft."
  },
  {
    id: 38,
    category: "NETWORKING",
    statement: "Ethernet cables are all the same  - brand doesn't matter.",
    answer: false,
    relatedProductId: null,
    explanation: "The category matters  - Cat 5e supports up to 1 Gbps, Cat 6 handles 10 Gbps at short distances, and Cat 6a does 10 Gbps at 100m. Cheap cables may not meet the rated specs."
  },
  {
    id: 39,
    category: "NETWORKING",
    statement: "A VPN always slows down your internet speed.",
    answer: true,
    relatedProductId: null,
    explanation: "VPNs add encryption overhead and route traffic through remote servers, which inevitably adds latency. The slowdown is usually small on good VPNs, but it's always there."
  },
  {
    id: 40,
    category: "ROUTER",
    statement: "You should change your router's default admin password immediately after setup.",
    answer: true,
    relatedProductId: null,
    explanation: "Default admin credentials are publicly known. Anyone on your network (or an attacker) can access your router settings if you don't change them. Do this first."
  },

  // ──────────────────────────────────────────
  //  NAS (Network Attached Storage) MYTHS (41–46)
  // ──────────────────────────────────────────
  {
    id: 41,
    category: "NAS",
    statement: "A NAS is just an expensive external hard drive.",
    answer: false,
    relatedProductId: null,
    explanation: "A NAS is a mini server  - it runs apps, streams media, syncs files across devices, handles backups, and is accessible from anywhere. Far more than a simple drive."
  },
  {
    id: 42,
    category: "NAS",
    statement: "RAID on a NAS is not a substitute for proper backups.",
    answer: true,
    relatedProductId: null,
    explanation: "RAID protects against drive failure, not against accidental deletion, ransomware, or fire. You still need separate backups  - ideally offsite or in the cloud."
  },
  {
    id: 43,
    category: "NAS",
    statement: "You need IT expertise to set up and manage a modern NAS device.",
    answer: false,
    relatedProductId: null,
    explanation: "Modern NAS devices from Synology and others have browser-based GUIs that are as easy as a smartphone. Setup wizards walk you through everything in minutes."
  },
  {
    id: 44,
    category: "NAS",
    statement: "A NAS can serve as your personal cloud storage alternative to Google Drive or Dropbox.",
    answer: true,
    relatedProductId: null,
    explanation: "NAS devices offer file sync, remote access, and mobile apps  - all the features of cloud storage, but your data stays on your own hardware. No monthly subscription fees."
  },
  {
    id: 45,
    category: "NAS",
    statement: "Using a router's USB port for a hard drive is just as good as a dedicated NAS.",
    answer: false,
    relatedProductId: null,
    explanation: "Router USB storage is extremely slow, has no redundancy, limited app support, and poor file management. A dedicated NAS is vastly more capable, reliable, and faster."
  },
  {
    id: 46,
    category: "NAS",
    statement: "NAS devices consume a lot of electricity and are expensive to run 24/7.",
    answer: false,
    relatedProductId: null,
    explanation: "Most 2-bay NAS devices consume only 15–30 watts  - less than a light bulb. With drive hibernation, annual electricity costs are typically under ₹2,000."
  },

  // ──────────────────────────────────────────
  //  GPU & GRAPHICS CARD MYTHS (47–51)
  // ──────────────────────────────────────────
  {
    id: 47,
    category: "GPU",
    statement: "You need the latest GPU to play modern games.",
    answer: false,
    relatedProductId: "gpu-1",
    explanation: "Most games run great on mid-range GPUs from the last 2–3 years. Don't fall for the hype cycle  - a 2-year-old card still handles 1080p and even 1440p well."
  },
  {
    id: 48,
    category: "GPU",
    statement: "More VRAM always means better gaming performance.",
    answer: false,
    relatedProductId: "gpu-1",
    explanation: "VRAM matters only if you actually exceed it (high-res textures, 4K). A GPU with 8GB VRAM but a weak chip will lose to a strong chip with 6GB VRAM every time."
  },
  {
    id: 49,
    category: "GPU",
    statement: "GPU thermal throttling can cause noticeable frame drops in games.",
    answer: true,
    relatedProductId: "gpu-1",
    explanation: "When a GPU overheats, it reduces its clock speed to cool down. This directly causes FPS drops. Proper case ventilation and fan curves prevent this."
  },
  {
    id: 50,
    category: "GPU",
    statement: "Integrated graphics are useless for anything beyond basic desktop use.",
    answer: false,
    relatedProductId: "gpu-1",
    explanation: "Modern integrated GPUs (AMD Ryzen 7000G, Intel Iris Xe) can handle light gaming, 4K video playback, and even some video editing. They've improved massively."
  },
  {
    id: 51,
    category: "GPU",
    statement: "Your GPU needs driver updates regularly for best performance and stability.",
    answer: true,
    relatedProductId: "gpu-1",
    explanation: "GPU drivers include game optimizations, bug fixes, and security patches. Outdated drivers can cause crashes, lower FPS, or compatibility issues with new games."
  },

  // ──────────────────────────────────────────
  //  PROCESSOR & MOTHERBOARD MYTHS (52–57)
  // ──────────────────────────────────────────
  {
    id: 52,
    category: "PROCESSOR",
    statement: "A higher GHz number always means a faster processor.",
    answer: false,
    relatedProductId: null,
    explanation: "Clock speed is only one factor. Architecture, core count, cache size, and IPC (instructions per clock) all matter. A newer 3.5 GHz chip can destroy an older 4.5 GHz one."
  },
  {
    id: 53,
    category: "PROCESSOR",
    statement: "Modern CPUs can dynamically boost their clock speed when extra performance is needed.",
    answer: true,
    relatedProductId: null,
    explanation: "Technologies like Intel Turbo Boost and AMD Precision Boost automatically increase clock speeds on active cores when thermal and power headroom allows."
  },
  {
    id: 54,
    category: "MOTHERBOARD",
    statement: "An expensive motherboard will make your CPU run faster.",
    answer: false,
    relatedProductId: null,
    explanation: "The CPU runs at the same speed regardless of motherboard price. Expensive boards add features like better VRMs, more USB ports, Wi-Fi, and overclocking support  - not raw speed."
  },
  {
    id: 55,
    category: "MOTHERBOARD",
    statement: "You must update your motherboard BIOS to support newer CPUs on the same socket.",
    answer: true,
    relatedProductId: null,
    explanation: "Motherboard manufacturers release BIOS updates to add support for new CPU models. Without the update, a newer chip may not boot even if the socket is physically compatible."
  },
  {
    id: 56,
    category: "PROCESSOR",
    statement: "An i7 processor is always better than an i5.",
    answer: false,
    relatedProductId: null,
    explanation: "A current-gen i5 can outperform an older-gen i7. Generation matters more than the i5/i7 branding. Always compare specific model numbers, not just tier names."
  },
  {
    id: 57,
    category: "MOTHERBOARD",
    statement: "You need a Z-series motherboard to use an Intel Core processor.",
    answer: false,
    relatedProductId: null,
    explanation: "B-series boards (B760, B660) run Intel Core processors perfectly fine. Z-series is only needed if you want to overclock an unlocked 'K' series CPU."
  },

  // ──────────────────────────────────────────
  //  KEYBOARD & PERIPHERAL MYTHS (58–62)
  // ──────────────────────────────────────────
  {
    id: 58,
    category: "KEYBOARD",
    statement: "Mechanical keyboards are always louder than membrane keyboards.",
    answer: false,
    relatedProductId: null,
    explanation: "Mechanical switches come in many types. Linear switches (like Cherry MX Red or Silent Red) are quieter than most membrane keyboards. It depends on the switch, not the technology."
  },
  {
    id: 59,
    category: "KEYBOARD",
    statement: "Ergonomic keyboards can genuinely help reduce wrist pain during long work sessions.",
    answer: true,
    relatedProductId: null,
    explanation: "Split and contoured ergonomic designs reduce ulnar deviation and wrist extension  - two major causes of repetitive strain injuries. The science backs this up."
  },
  {
    id: 60,
    category: "PERIPHERAL",
    statement: "Wireless mice always have noticeable input lag compared to wired ones.",
    answer: false,
    relatedProductId: null,
    explanation: "Modern wireless gaming mice (2.4GHz) have latency comparable to or even lower than wired mice. The 'wireless = lag' myth died years ago with current tech."
  },
  {
    id: 61,
    category: "KEYBOARD",
    statement: "RGB lighting on keyboards and peripherals uses extra power and reduces battery life.",
    answer: true,
    relatedProductId: null,
    explanation: "RGB LEDs absolutely consume extra power. On wireless keyboards and mice, turning off or dimming the RGB can significantly extend battery life."
  },
  {
    id: 62,
    category: "PERIPHERAL",
    statement: "A docking station can replace all the ports your thin laptop is missing.",
    answer: true,
    relatedProductId: null,
    explanation: "A good USB-C docking station adds HDMI, USB-A, Ethernet, SD card slots, and more  - turning a single-port ultrabook into a full desktop workstation."
  },

  // ──────────────────────────────────────────
  //  AUDIO & HEADPHONE MYTHS (63–66)
  // ──────────────────────────────────────────
  {
    id: 63,
    category: "AUDIO",
    statement: "Noise-cancelling headphones can damage your hearing over time.",
    answer: false,
    relatedProductId: null,
    explanation: "Active noise cancellation (ANC) works by producing anti-phase sound waves  - it reduces noise without raising volume. If anything, ANC protects hearing by letting you listen at lower volumes."
  },
  {
    id: 64,
    category: "AUDIO",
    statement: "Higher-priced headphones always sound better than budget ones.",
    answer: false,
    relatedProductId: null,
    explanation: "There's a sweet spot around ₹3,000–₹8,000 where quality jumps dramatically. Beyond that, you pay for marginal improvements, brand prestige, and premium materials."
  },
  {
    id: 65,
    category: "AUDIO",
    statement: "Wired headphones deliver better audio quality than Bluetooth headphones.",
    answer: true,
    relatedProductId: null,
    explanation: "Wired connections transmit uncompressed audio. Bluetooth uses codecs (SBC, AAC, LDAC) that compress the signal. For critical listening, wired still wins  - though the gap is narrowing."
  },
  {
    id: 66,
    category: "AUDIO",
    statement: "USB headsets are better for video calls than 3.5mm jack headsets.",
    answer: true,
    relatedProductId: null,
    explanation: "USB headsets have their own sound card built in, bypassing your laptop's often mediocre onboard audio. This typically means clearer mic input and more consistent call quality."
  },

  // ──────────────────────────────────────────
  //  COOLING & CABINET MYTHS (67–70)
  // ──────────────────────────────────────────
  {
    id: 67,
    category: "COOLING",
    statement: "Liquid cooling is always better than air cooling.",
    answer: false,
    relatedProductId: "cooling-1",
    explanation: "High-end air coolers often match or beat budget AIOs. Liquid cooling can be quieter, but it's pricier, more complex, and has more failure points."
  },
  {
    id: 68,
    category: "COOLING",
    statement: "More fans in a PC case always means better cooling.",
    answer: false,
    relatedProductId: "cooling-1",
    explanation: "Airflow direction matters more than fan count. Properly configured intake and exhaust fans (positive pressure) beat randomly placed fans every time."
  },
  {
    id: 69,
    category: "COOLING",
    statement: "Keeping your PC on the carpet can cause overheating.",
    answer: true,
    relatedProductId: "cooling-1",
    explanation: "Carpet blocks bottom intake vents, traps dust, and reduces airflow. This genuinely causes higher temperatures. Place your PC on a hard, flat surface."
  },
  {
    id: 70,
    category: "COOLING",
    statement: "Opening your PC case provides better cooling than keeping it closed.",
    answer: false,
    relatedProductId: "cooling-1",
    explanation: "An open case disrupts designed airflow paths. Dust enters freely and fans can't create proper air pressure. A well-ventilated closed case cools better."
  },

  // ──────────────────────────────────────────
  //  POWER SUPPLY MYTHS (71–73)
  // ──────────────────────────────────────────
  {
    id: 71,
    category: "POWER",
    statement: "Any power supply will work as long as the wattage is enough.",
    answer: false,
    relatedProductId: "psu-1",
    explanation: "PSU quality matters hugely  - cheap units can deliver unstable voltage, damage components, or even be a fire hazard. Always check for 80+ Bronze rating or higher."
  },
  {
    id: 72,
    category: "POWER",
    statement: "An 80+ Gold PSU wastes less electricity as heat compared to a non-rated PSU.",
    answer: true,
    relatedProductId: "psu-1",
    explanation: "80+ Gold certification means 87%+ efficiency. A cheap non-rated PSU might only be 70% efficient  - wasting 30% of power as heat, costing more on your electricity bill."
  },
  {
    id: 73,
    category: "POWER",
    statement: "A modular PSU improves your PC's performance.",
    answer: false,
    relatedProductId: "psu-1",
    explanation: "Modular PSUs don't add speed. They just let you remove unused cables, improving airflow and making cable management easier inside your case. Aesthetic and practical, not performance."
  },

  // ──────────────────────────────────────────
  //  PRINTER MYTHS (74–76)
  // ──────────────────────────────────────────
  {
    id: 74,
    category: "PRINTER",
    statement: "Inkjet printers are always cheaper to own than laser printers.",
    answer: false,
    relatedProductId: null,
    explanation: "Inkjet printers are cheaper upfront but ink cartridges are expensive per page. For regular printing, ink tank or laser printers have a much lower cost per page over time."
  },
  {
    id: 75,
    category: "PRINTER",
    statement: "Ink tank printers have dramatically lower running costs than cartridge-based printers.",
    answer: true,
    relatedProductId: null,
    explanation: "Ink tank systems (like Epson EcoTank or Brother InkBenefit) can print thousands of pages from a single refill  - bringing per-page cost down to a fraction of a paisa."
  },
  {
    id: 76,
    category: "PRINTER",
    statement: "You must print regularly to prevent an inkjet printer from clogging.",
    answer: true,
    relatedProductId: null,
    explanation: "Inkjet nozzles can dry out and clog if unused for weeks. Printing at least a test page once a week keeps the ink flowing and prevents expensive head cleaning cycles."
  },

  // ──────────────────────────────────────────
  //  LAPTOP MYTHS (77–82)
  // ──────────────────────────────────────────
  {
    id: 77,
    category: "LAPTOP",
    statement: "Refurbished laptops are unreliable and won't last long.",
    answer: false,
    relatedProductId: null,
    explanation: "Professionally refurbished laptops (graded and tested by trusted sellers) can last years. Many come with warranties and are a smart way to get premium specs on a budget."
  },
  {
    id: 78,
    category: "LAPTOP",
    statement: "Laptops with SSD boot significantly faster than those with HDD.",
    answer: true,
    relatedProductId: "ssd-1",
    explanation: "An SSD can boot Windows in 10–15 seconds versus 45–90 seconds on an HDD. It's the single most impactful upgrade for an older laptop."
  },
  {
    id: 79,
    category: "LAPTOP",
    statement: "Closing your laptop lid is the same as shutting it down.",
    answer: false,
    relatedProductId: "battery-1",
    explanation: "Closing the lid usually puts the laptop to sleep  - it still uses a small amount of power and keeps your session in RAM. Shut down fully to save battery during long periods."
  },
  {
    id: 80,
    category: "LAPTOP",
    statement: "Using a laptop cooling pad makes a noticeable difference in temperature.",
    answer: true,
    relatedProductId: "cooling-1",
    explanation: "Cooling pads can drop CPU temps by 5–10°C, especially on gaming laptops or during heavy workloads. They won't work miracles, but the difference is measurable."
  },
  {
    id: 81,
    category: "LAPTOP",
    statement: "Thin and light laptops can't handle serious productivity workloads.",
    answer: false,
    relatedProductId: null,
    explanation: "Modern ultrabooks with 13th/14th gen Intel or Ryzen 7000 series CPUs handle office work, coding, video calls, and even light video editing with ease."
  },
  {
    id: 82,
    category: "LAPTOP",
    statement: "Upgrading your laptop's RAM and SSD yourself is usually possible and worthwhile.",
    answer: true,
    relatedProductId: "ram-1",
    explanation: "Most business and mid-range laptops allow RAM and SSD upgrades. It's often the cheapest way to extend a laptop's life by 2–3 years."
  },

  // ──────────────────────────────────────────
  //  SECURITY & SOFTWARE MYTHS (83–86)
  // ──────────────────────────────────────────
  {
    id: 83,
    category: "SECURITY",
    statement: "Macs don't get viruses.",
    answer: false,
    relatedProductId: null,
    explanation: "Macs are less targeted than Windows but absolutely not immune. macOS malware has grown significantly in recent years. Use caution regardless of platform."
  },
  {
    id: 84,
    category: "SECURITY",
    statement: "Public Wi-Fi networks are risky for accessing banking or sensitive accounts.",
    answer: true,
    relatedProductId: null,
    explanation: "Public Wi-Fi can be intercepted or spoofed. Even with HTTPS, attackers can set up rogue hotspots. Use a VPN or mobile data for sensitive tasks."
  },
  {
    id: 85,
    category: "SECURITY",
    statement: "Windows Defender is enough antivirus protection for most home users.",
    answer: true,
    relatedProductId: null,
    explanation: "Windows Defender has improved massively and scores well in independent tests. For most users with safe browsing habits, it provides solid baseline protection without needing a paid antivirus."
  },
  {
    id: 86,
    category: "SECURITY",
    statement: "Formatting your hard drive completely erases all data beyond recovery.",
    answer: false,
    relatedProductId: "ssd-1",
    explanation: "A standard quick format only removes file references  - the data is still recoverable with free tools. You need a full format or a secure erase tool to truly wipe data."
  },

  // ──────────────────────────────────────────
  //  GAMING MYTHS (87–89)
  // ──────────────────────────────────────────
  {
    id: 87,
    category: "GAMING",
    statement: "Gaming PCs consume too much power and are expensive to run.",
    answer: false,
    relatedProductId: "gpu-1",
    explanation: "A typical gaming PC draws 300–500W under load  - similar to a small heater. At Indian electricity rates, even heavy gaming costs ₹200–400/month in power."
  },
  {
    id: 88,
    category: "GAMING",
    statement: "An SSD reduces game loading times compared to an HDD.",
    answer: true,
    relatedProductId: "ssd-1",
    explanation: "Games on an SSD can load 2–5x faster. Some modern games with DirectStorage even require an NVMe SSD for the best experience."
  },
  {
    id: 89,
    category: "GAMING",
    statement: "You need a gaming mouse to be competitive in online games.",
    answer: false,
    relatedProductId: null,
    explanation: "A gaming mouse helps with sensor accuracy and comfort, but a decent ₹500 mouse works fine for most players. Skill, practice, and internet stability matter far more."
  },

  // ──────────────────────────────────────────
  //  CABLE & CONNECTIVITY MYTHS (90–93)
  // ──────────────────────────────────────────
  {
    id: 90,
    category: "CABLE",
    statement: "Expensive HDMI cables give better picture quality than cheap ones.",
    answer: false,
    relatedProductId: "monitor-1",
    explanation: "HDMI is a digital signal  - it either works or it doesn't. A ₹200 HDMI cable delivers the exact same picture as a ₹3,000 one, as long as it supports the right version (HDMI 2.1 for 4K 120Hz)."
  },
  {
    id: 91,
    category: "CABLE",
    statement: "USB-C cables all support the same speeds and power delivery.",
    answer: false,
    relatedProductId: null,
    explanation: "USB-C is just the connector shape. The cable inside might be USB 2.0 (480 Mbps), USB 3.2 (10 Gbps), or Thunderbolt 4 (40 Gbps). Always check the cable's rated spec."
  },
  {
    id: 92,
    category: "CABLE",
    statement: "Using a USB hub can reduce the transfer speed of connected devices.",
    answer: true,
    relatedProductId: null,
    explanation: "All devices on a hub share the host port's bandwidth. Plugging multiple fast devices into one USB 3.0 hub means they split the 5 Gbps limit, slowing each one down."
  },
  {
    id: 93,
    category: "CABLE",
    statement: "DisplayPort is generally better than HDMI for high-end PC gaming monitors.",
    answer: true,
    relatedProductId: "monitor-1",
    explanation: "DisplayPort supports higher refresh rates, adaptive sync (FreeSync/G-Sync), and daisy-chaining. For PC gaming at 1440p 144Hz+, DP is the preferred choice."
  },

  // ──────────────────────────────────────────
  //  GENERAL TECH MYTHS (94–100)
  // ──────────────────────────────────────────
  {
    id: 94,
    category: "GENERAL TECH",
    statement: "Shutting down your PC every night extends its lifespan.",
    answer: false,
    relatedProductId: null,
    explanation: "Modern PCs handle sleep mode efficiently. Frequent power cycling (on/off) can actually stress components more than leaving the system in sleep mode overnight."
  },
  {
    id: 95,
    category: "GENERAL TECH",
    statement: "Dust buildup inside a PC can cause it to overheat and slow down.",
    answer: true,
    relatedProductId: "cooling-1",
    explanation: "Dust clogs heatsinks and fans, reducing airflow and trapping heat. This causes thermal throttling  - your CPU and GPU literally slow down to avoid damage. Clean your PC every 3–6 months."
  },
  {
    id: 96,
    category: "GENERAL TECH",
    statement: "You should always buy the latest generation of hardware for the best value.",
    answer: false,
    relatedProductId: null,
    explanation: "Previous-gen hardware often gets significant price drops while still offering excellent performance. A last-gen CPU or GPU can be the smartest value buy."
  },
  {
    id: 97,
    category: "GENERAL TECH",
    statement: "An AI PC with an NPU can run certain AI tasks faster and more efficiently than a standard PC.",
    answer: true,
    relatedProductId: null,
    explanation: "NPUs (Neural Processing Units) are specialized chips designed for AI workloads. They handle tasks like real-time translation, image upscaling, and local AI assistants far more efficiently than a CPU or GPU alone."
  },
  {
    id: 98,
    category: "GENERAL TECH",
    statement: "Putting a magnet near your laptop will erase your data.",
    answer: false,
    relatedProductId: "ssd-1",
    explanation: "SSDs are immune to magnets  - they store data electronically, not magnetically. Even for HDDs, you'd need an extremely powerful industrial magnet to cause damage."
  },
  {
    id: 99,
    category: "GENERAL TECH",
    statement: "Keeping too many browser tabs open genuinely slows down your computer.",
    answer: true,
    relatedProductId: "ram-1",
    explanation: "Each Chrome tab can use 100–500 MB of RAM. With 30+ tabs open, you can easily consume 8 GB+ of memory, causing slowdowns, fan noise, and battery drain."
  },
  {
    id: 100,
    category: "MAINTENANCE",
    statement: "Quality thermal paste lasts 3–5 years and doesn't need annual replacement.",
    answer: true,
    relatedProductId: "cooling-1",
    explanation: "Good thermal paste maintains conductivity for years. Reapply only if your CPU temps spike significantly or you've removed the heatsink for other maintenance."
  }

];
